/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import progressBarBackgroundColor from 'common/ProgressBarBackgroundColor';
import { useTransition, animated } from 'react-spring';
import { getDuration } from 'common';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

export const FadeOut = ({ children, fade, animationProps, disableAnimation }) => {
  const transitions = useTransition(!fade, null, {
    from: { opacity: 1 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: getDuration(Tokens.SPEED.SPEED_SLOW) },
    immediate: disableAnimation,
    ...animationProps
  });

  return transitions.map(({ item, key, props }) =>
    item && (
    <animated.div key={key} style={props}>
      {children}
    </animated.div>
    ));
};

export const circleAnimation = keyframes`
0% {
  stroke-dashoffset: 90;
  transform: rotate(0deg);
}

50% {
  stroke-dashoffset: 10;
  transform: rotate(135deg);
}

100% {
  stroke-dashoffset: 90;
  transform: rotate(360deg);
}
`;
export const circleAnimationRtl = keyframes`
0% {
  stroke-dashoffset: 90;
  transform: rotate(360deg);
}

50% {
  stroke-dashoffset: 10;
  transform: rotate(225deg);
}

100% {
  stroke-dashoffset: 90;
  transform: rotate(00deg);
}
`;


const svgAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const svgAnimationRtl = keyframes`
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
`;

const circleColors = $theme => keyframes`
  0% {
    stroke: ${$theme.progressInitialColor};
  }

  50% {
    stroke: rgb(${progressBarBackgroundColor(50, $theme)});
  }

  100% {
    stroke: ${$theme.progressFinalColor};
  }
`;

export default {
  Wrapper: styled.div`
    align-items: center;
    height: 100%;
    width: 100%;
  `,
  SvgContainer: styled.svg`
    height: 100%;
    width: 100%;
    animation: 1.8s linear infinite ${svgAnimation};
    ${({ rtl }) => rtl && css`
      animation: 1.8s linear infinite ${svgAnimationRtl};
    `}
    ${({ $disableAnimation }) => $disableAnimation && css`
      animation-duration:${props => `${props.$animationDuration}s`};
    `}
    overflow: hidden;
    fill: transparent;
    margin: auto;
  `,
  CircleContainer: styled.circle`
    animation-duration: 1.8s, 4s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    transition: none;
    cx: 24;
    cy: 24;
    r: 18.5;
    ${({ $theme, rtl }) => !rtl && css`
        animation-name: ${circleAnimation}, ${circleColors($theme)};
  `}
    ${({ $theme, rtl }) => rtl && css`
      animation-name: ${circleAnimationRtl}, ${circleColors($theme)};
    `}
    ${({ $disableAnimation }) => $disableAnimation && css`
      animation-duration:${props => `${props.$animationDuration}s`};
    `}
    stroke-dasharray: 116.1;
    transform-origin: center;
    fill: transparent;
    stroke-linecap: round;
  `,
  Overlay: styled.div`
    width: ${props => `${props.overlaySize}px`};
    height: ${props => `${props.overlaySize}px`};
    padding: ${Tokens.SPACING.SPACING_2};
    border-radius: 50%;
    overflow: hidden;
  `,

};
